var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDiceAiicon = function SvgDiceAiicon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dice_ai_icon_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.4,
    height: 12.4,
    x: 3.749,
    y: 0.331,
    stroke: "#fff",
    strokeWidth: 1.6,
    rx: 2.2,
    transform: "rotate(16 3.75 .331)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.286,
    cy: 4.908,
    r: 1,
    fill: "#fff",
    transform: "rotate(16 6.286 4.908)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.908,
    cy: 9.714,
    r: 1,
    fill: "#fff",
    transform: "rotate(16 4.908 9.714)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 1,
    fill: "#fff",
    transform: "rotate(16 8 8)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.714,
    cy: 11.092,
    r: 1,
    fill: "#fff",
    transform: "rotate(16 9.714 11.092)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.092,
    cy: 6.286,
    r: 1,
    fill: "#fff",
    transform: "rotate(16 11.092 6.286)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "dice_ai_icon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgDiceAiicon;